import { AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { ProjetoList } from '../../models/projeto-list.model';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-projeto-list',
  templateUrl: './projeto-list.component.html',
  styleUrls: ['./projeto-list.component.scss']
})

export class ProjetoListComponent extends BaseListComponent<ProjetoList> implements OnInit, OnDestroy, AfterViewInit {

  projetoList: ProjetoList[] = [];
  infoView: any[] = [];
  modalRef?: BsModalRef;

  listaTiposProjetos : any = [
    {'id':1,'label':'Programa'},
    {'id':2,'label':'Projeto Agregador'},
    {'id':3,'label':'Projeto'},
  ];
  tipo:any;

  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  @ViewChild('modal') modal: TemplateRef<any>;

  constructor(
    private router: Router,
    public pesquisaGeralService: PesquisaGeralService,
    private modalService: BsModalService,
  ) {
    super();
  }

  ngOnInit() {
    this.initDataTable();
    this.loaded();

    this.addSub(EventSharedService.get('atualizaProjetos').subscribe((res: ProjetoList[]) => {
      this.projetoList = res;
      this.initLoadDataTable(this.projetoList);
    }));
  }

  ngAfterViewInit() {
    this.initLoadDataTable();
  }

  ngOnDestroy(): void {
    this.dtOptions1.dtTrigger.unsubscribe();
    this.unsubscribeList();
  }

  initLoadDataTable(res: ProjetoList[] = null) {
    this.dtOptions1.data = res;
    this.dtRerender(this.dtOptions1)
  }

  initDataTable() {
    this._language.sEmptyTable = "Realize uma pesquisa para encontrar projetos";
    this._language.sSearch = "Pesquisa Rápida "
    this.dtOptions1 = {
      language: this._language,
      dtTrigger: new Subject<any>(),
      columns: [
        {
          title: 'Projetos',
          data: null,
          render: function (data, type, row, meta) {
            let title = data.title;
            if (data.type_id === 1) {
              title += '<br/><span class="badge bg-primary">Programa</span>';
            } else if (data.type_id === 2) {
              title += '<br/><span class="badge bg-info text-dark btn-projeto-agregador">Projeto Agregador</span>';
            }
            if (data?.resp_nome) {
              title += `<span class="resp-info"><br/>Resp.: ${data?.resp_nome}
                          <span class="icone-info"><i class="pl-1 fa fas fa-user icon"></i></span>
                          <div data-info="${data.id}" class="manager-info">`;
              if (data?.resp_email) {
                title += `<div>E-mail: ${data?.resp_email}</div>`
              }
              if (data?.resp_tel) {
                title += `<div>Telefone: ${data?.resp_tel}</div> `
              }

              data.adj = ["r", "g"];
              if (data?.resp_adj?.length > 0) {
                data.resp_adj.forEach(item => {
                  if (item?.resp_nome) {
                    title += `<hr><span class="resp-info">Adj.: ${item?.resp_nome}<div class="manager-info-adj">`;
                    if (item?.resp_email) {
                      title += `<div>E-mail: ${item?.resp_email}</div>`
                    }
                    if (item?.resp_tel) {
                      title += `<div>Telefone: ${item?.resp_tel}</div> `
                    }
                    title += `</div></span>`;
                  }
                });
              }
              title += `</div></span>`;
            }
            return title;
          },
        },
        {
          title: 'Órgão',
          data: 'agency_name',
          className: "w-10p text-center",
        },
        {
          title: 'Previsto',
          data: 'cron_foreseen_executed',
          className: "w-8p text-center",
        },
        {
          title: 'Executado',
          data: 'cron_executed',
          className: "w-8p text-center",
        },
        {
          title: 'Status',
          data: null,
          className: "w-12p text-center",
          render: function (data, type, row, meta) {
            let status = null;
            if (data?.geral_analysis_stat_name && data?.geral_analysis_status1) {
              status = `<div class="situacao">${data.geral_analysis_stat_name}<strong class="text">${data.geral_analysis_status1}</strong></div>`;
            }
            return status;
          },
        },
        {
          title: 'Atualização',
          data: 'max_ctr_dth_atu',
          className: "w-12p text-center",
        },
        {
          title: 'Ações',
          className: "w-5p text-center",
          data: null,
          render: function (data, type, row, meta) {
            if (data.type_id === 0) {
              return '<button class="btn-success btn btn-xs btn-view m-r-xs"><i class="fa fas fa-search"></i></button>';
            } else if(data.type_id === 1){
              return '';
            } else if(data.type_id === 2){
              return '<button class="btn-info btn btn-xs btn-projeto-agregador m-r-xs"><i class="fa fas fa-search"></i></button>';
            }

          },
        },
      ],
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        $('.icon', row).off('click');
        $('.icon', row).on('click', () => {
          this.viewInfoResp(data);
        });
        $('.btn-view', row).off('click');
        $('.btn-view', row).on('click', () => {
          this.updateClickHandler(data);
        });
        $('.btn-projeto-agregador', row).off('click');
        $('.btn-projeto-agregador', row).on('click', () => {
          this.projetoAgregadorClickHandler(data);
        });
        return row;
      },
    };
  }

  // novo() { this.router.navigate(['projetos','adicionar']) }

  viewInfoResp(data: any) {
    const verifyInfoResp = this.projetoList.some((item) => {
      return (item.id === data.id && item?.resp_adj?.length > 0);
    });

    if (!verifyInfoResp && !this.infoView.includes(data.id)) {
      this.loading();
      this.addSub(
        this.pesquisaGeralService.responsavelAdjProjeto(data.id).subscribe({
          next: async (res) => {
            if (res?.length > 0) {
              const dataTable = await this.dtElement.dtInstance;
              const currentPage = dataTable.page();
              const currentSearch = dataTable.search();
              const currentPageLength = dataTable['context'][0]["_iDisplayLength"];
              this.projetoList.find(item => {
                if (item.id === data.id) {
                  item.resp_adj = res;
                }
              });
              this.dtOptions1.data = this.projetoList;
              if (currentSearch) {
                this.dtOptions1.search = { search: currentSearch }
              }
              this.dtOptions1.pageLength = currentPageLength
              this.dtRerender(this.dtOptions1)
              setTimeout(() => {
                this.dtElement.dtInstance.then((dtInstance: any) => {
                  const totalItems = dtInstance.page.info().recordsTotal;
                  const newPageStart = currentPage * currentPageLength;
                  if (newPageStart < totalItems) {
                    dtInstance.page(Math.floor(newPageStart / currentPageLength)).draw('page');
                  }
                  this.openManagerInfo(data);
                  this.loaded();
                });
              }, 50);
            } else {
              this.infoView.push(data.id);
              this.openManagerInfo(data);
              this.loaded();
            }
          },
        })
      )
    } else {
      this.openManagerInfo(data);
    }
  }

  openManagerInfo(data) {
    $(`[data-info="${data.id}"]`).toggleClass("active");
  }

  updateClickHandler(data: any): void {
    this.router.navigate(['projetos/projeto/', data.id]);
  }

  projetoAgregadorClickHandler(data: any): void {
    this.router.navigate(['projetos/agregador/', data.id]);
  }

  novo(){
    this.router.navigate(['projetos/projeto/adicionar'])
  }

  dtRerender(dtOptions: any) {
    dtOptions.destroy = true;
    dtOptions.dtTrigger.next();
  }


  openModal() {
    // this.execucaoAlterar = {
    //   year_ini: this.execucaoList?.length ? this.execucaoList[0]?.year : null,
    //   year_end: this.execucaoList?.length ? this.execucaoList[this.execucaoList?.length - 1]?.year : null
    // }
    this.modalRef = this.modalService.show(this.modal);
  }

  closeModal() {
    this.modalRef?.hide();
  }

}
